import { Builder } from '@builder.io/sdk';
import { ExpertQuote } from './ExpertQuote';

const ExpertQuoteConfig = {
  name: 'ExpertQuote',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      required: true,
    },
    {
      name: 'body',
      type: 'string',
      required: true,
    },
    {
      name: 'link',
      type: 'string',
      required: false,
    },
    {
      name: 'expert',
      type: 'reference',
      model: 'expert',
      required: true,
    },
  ],
};

Builder.registerComponent(ExpertQuote, ExpertQuoteConfig);
